import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { InspecaoObraAprovacaoForm, InspecaoObraAprovacaoSchema } from "../../../schemas/ObraItensChecklistArea_cadastro/inspecao_obra_aprovacao";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { useEffect } from "react";
import { FuncionarioInformation } from "../../../../../../common/domain/models/funcionario_information";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * InspecaoObraAprovacaoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  funcionarioInformation: FuncionarioInformation | null;
  onClose: () => void;
  onSubmit: (form: InspecaoObraAprovacaoForm) => void;
};

export const InspecaoObraAprovacaoModal = ({
  open,
  saving,
  loading,
  funcionarioInformation,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<InspecaoObraAprovacaoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(InspecaoObraAprovacaoSchema),
  });

  useEffect(() => {
    if (open && funcionarioInformation) {
      hookForm.reset({
        usuario: funcionarioInformation.nomeFuncionario ?? "",
        data: new Date(),
      });
    }
  }, [
    open,
    funcionarioInformation,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Aprovar Verificação de Inspeção'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormInput
            name='usuario'
            label='Funcionário'
            readOnly={true}
            reactHookForm={hookForm}
          />

          <FormDatePickerInput
            name='data'
            label='Data'
            required={true}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>

    </BaseFormControlledModal>
  );
}